__turbopack_context__.v({
  "viewerDownloadButton": "download-button-module-scss-module___JD_kq__viewerDownloadButton",
  "viewerDownloadWrapper": "download-button-module-scss-module___JD_kq__viewerDownloadWrapper",
});
